const _ = require('lodash');

export function valueLabelFormat(value) {
  return value;
}

export function calculateValue(value) {
  return value;
}

export const excludeFilter = ['call_duration', 'exo_phone'];
export const excludeFilterForAnalyze = ['call_duration', 'exo_phone', 'speaker', 'search_logic'];

export const createFeatureFilter = (filters) => {
  if (!filters) return;
  return filters?.feature_filter?.reduce((r, a) => {
    r[a.categoryName] = [...(r[a.categoryName] || []), a];
    return r;
  }, {});
};

export const filterISEMPTY = (filter) => {
  // console.log("viewAnalytics:::::::::", filter);
  if (filter.lob_id.length <= 0) {
    return true;
  }
  return false;
};

export const TYPEOF_FIELD_FILTER = {
  DROPDOWN: 'dropdown',
  AUTO_SELECT: 'auto_select',
  AUTO_MULTIPLE_SELECT: 'auto_multiple_select',
  MULTIPLE_SELECT: 'multiple_select',
  RADIO: 'radio',
  RANGE: 'range',
  TEXTFIELD: 'text_field'
};

export function mergeFilterData(state, payload) {
  const { extra_filter, feature_filter, page_info } = payload;
  return {
    extra_filter: { ...state?.extra_filter, ...extra_filter },
    feature_filter: { ...state?.feature_filter, ...feature_filter },
    page_info: { ...state?.page_info, ...page_info }
  };
}

export function extractData(obj, keysToExtract) {
  const extractedData = {};

  for (const key of keysToExtract) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      extractedData[key] = obj[key];
    }
  }

  return extractedData;
}
// export function smoothMerge(obj1, obj2) {
//   return _.merge(obj1, obj2);
// }

export function smoothMerge(obj1, obj2) {
  // const mergedObject = { ...obj1 };
  for (const key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, key) && Object.prototype.hasOwnProperty.call(obj1[key], 'selected')) {
      if (!obj1[key]) {
        obj1[key] = {};
      }
      obj1[key].selected = null;
    }
  }
  return _.merge(obj1, obj2);
}
export function merge(obj1, obj2) {
  return _.merge(obj1, obj2);
}
export const MAIN_FILTER = {
  select_lob: {
    name: 'Select LOB',
    slug: 'select_lob',
    is_value: false,
    value: null,
    visible: true
  },
  select_team: {
    name: 'Select Team',
    slug: 'select_team',
    is_value: false,
    value: null,
    visible: true
  },
  select_agent: {
    name: 'Select Agent',
    slug: 'select_agent',
    is_value: false,
    value: null,
    visible: true
  }
};
